import { Text } from '@mantine/core';
import React, { FC } from 'react';

import { AuditLogType } from '@portals/types';

interface DeleteDeviceProps {
  auditLog: AuditLogType;
}

export const DeleteDevice: FC<DeleteDeviceProps> = ({ auditLog }) => (
  <Text size="sm">
    {auditLog?.params[0]?.model}: {auditLog?.params[0]?.display_name} Deleted
  </Text>
);
